"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const Text_1 = require("../../foundations/Typography/Text");
const hooks_1 = require("../../hooks");
const useId_1 = require("../../hooks/useId");
const CustomCheckmarkIcon_1 = __importDefault(require("./assets/CustomCheckmarkIcon"));
const CustomIndeterminateIcon_1 = __importDefault(require("./assets/CustomIndeterminateIcon"));
const Checkbox = ({ label, value, onChange, onBlur, indeterminate = false, error = false, disabled, required, id, ariaLabel }) => {
    const base0Id = (0, useId_1.useId)();
    const inputId = id !== null && id !== void 0 ? id : base0Id;
    const [isOutlineVisible, preventOutlineOnClick, handleFocus, handleBlur] = (0, hooks_1.useFocusControls)(onBlur);
    const isFilled = value || indeterminate;
    const checkboxStyles = react_1.default.useMemo(() => {
        return Object.assign(Object.assign({ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "spacing-6", minWidth: "spacing-6", height: "spacing-6", borderStyle: "solid", borderWidth: "2px", borderColor: error
                ? "input-stroke-error"
                : isFilled
                    ? "input-surface-enabled"
                    : "input-stroke-enabled", borderRadius: "radius-1", cursor: disabled ? "not-allowed" : "pointer", transition: "transition-color-medium", backgroundColor: isFilled
                ? error
                    ? "input-surface-error"
                    : "input-surface-enabled"
                : undefined }, (error
            ? {}
            : {
                ":hover": {
                    backgroundColor: isFilled ? "input-surface-hover" : undefined,
                    borderColor: isFilled
                        ? "input-surface-hover"
                        : "input-stroke-hover"
                },
                ":active": {
                    borderColor: "input-surface-click",
                    backgroundColor: "input-surface-click"
                }
            })), (isOutlineVisible && {
            outlineStyle: "solid",
            borderRadius: "radius-1",
            outlineColor: "focus",
            outlineWidth: "1px",
            outlineOffset: "1px"
        }));
    }, [error, isFilled, disabled, isOutlineVisible]);
    const labelStyles = react_1.default.useMemo(() => {
        return {
            display: "inline-flex",
            alignItems: "stretch",
            color: disabled ? "input-text-disabled" : "input-text",
            cursor: disabled ? "not-allowed" : "pointer",
            opacity: disabled ? "0.5" : "1",
            fontSize: "font-size-1",
            transition: "transition-color-medium",
            userSelect: "none"
        };
    }, [disabled]);
    const checkboxWrapperStyles = react_1.default.useMemo(() => {
        return {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "fit-content"
        };
    }, []);
    return (react_1.default.createElement(foundations_1.Box, { onMouseDown: preventOutlineOnClick, onMouseUp: preventOutlineOnClick, sx: checkboxWrapperStyles },
        react_1.default.createElement(foundations_1.Box, { as: "label", htmlFor: inputId, id: `${inputId}-label`, sx: labelStyles },
            react_1.default.createElement(foundations_1.Box, { as: "span", sx: {
                    display: "flex",
                    flexShrink: 0,
                    alignItems: "center"
                } },
                react_1.default.createElement(foundations_1.Box, { as: "input", type: "checkbox", id: inputId, checked: value, onChange: onChange, onFocus: handleFocus, onBlur: handleBlur, disabled: disabled, "aria-invalid": !!error, "aria-checked": value, "aria-disabled": disabled, "aria-required": required, "aria-label": ariaLabel }),
                react_1.default.createElement(foundations_1.Box, { as: "span", sx: checkboxStyles },
                    value && react_1.default.createElement(CustomCheckmarkIcon_1.default, null),
                    !value && indeterminate && react_1.default.createElement(CustomIndeterminateIcon_1.default, null))),
            label && (react_1.default.createElement(Text_1.Text, { variant: "body-1-regular", as: "span", sx: Object.assign(Object.assign({}, labelStyles), { display: "flex", flexDirection: "column", justifyContent: "center", ml: 2 }) }, label)))));
};
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map